import { Callout } from './components/callout.tsx'

export const meta = () => [
	{ title: 'Usage & Billing · xcelera docs' },
	{
		name: 'description',
		content:
			'How audit credits work: plan allocations, monthly resets, report retention, and what happens when your organization runs out.',
	},
]

# Usage & Billing

Every plan includes a monthly allocation of audit credits. Running an audit consumes one credit.

## Plans

| Plan     | Credits | Features                                                                                                                     |
| -------- | ------- | ---------------------------------------------------------------------------------------------------------------------------- |
| **Free** | 50      | Daily scheduling, one region (US), MFA, passkeys & SSO, 30-day report retention                                              |
| **Pro**  | 1,000   | Hourly & custom intervals, 22 regions, stabilized audits, authenticated audits, API & CLI, webhooks, 2-year report retention |
| **Team** | 5,000   | Everything in Pro, plus team & access management                                                                             |

Prices are on the [pricing page](/pricing).

## Credits

One audit costs one credit, whether it runs Lighthouse once or five times. The runs inside an audit exist to stabilize the result, not to multiply the cost.

Your usage period is one month long, anchored to when it started (a period beginning February 5th resets March 5th). Unused credits don't roll over.

## Report retention

Full Lighthouse reports are kept for 30 days on Free and 2 years on paid plans.

## Monitoring usage

**Settings → Usage** shows your current period: credits used, credits remaining, a chart of consumption across past periods, and a table of recent audit credit events.

## When credits run out

Scheduled audits skip their runs until the period resets, then resume on their normal schedule. Manual audits fail to start. API requests return `429` with the error code `usage_limit_exceeded`.

<Callout type="tip">
	Short-interval schedules add up fast: one page audited hourly uses about 720
	credits a month. Check **Settings → Usage** before tightening an interval.
</Callout>
